// 用户名和密码的缓存键名常量
const FINE_USERNAME = 'fine_username'
const FINE_PASSWORD = 'fine_password'
const FINE_AUTH_TOKEN = 'fine_auth_token'
const FINE_REMEMBER_LOGIN = 'fine_remember_login'

export const removeFineUser = () => {
  localStorage.removeItem(FINE_USERNAME)
  localStorage.removeItem(FINE_PASSWORD)
  cookieStore.delete(FINE_AUTH_TOKEN)
  cookieStore.delete(FINE_REMEMBER_LOGIN)
}
export const checkFineUser = () => {
  const res = localStorage.getItem(FINE_USERNAME) && localStorage.getItem(FINE_PASSWORD)
  return res
}
// 保存用户名和密码
export const saveFineUser = (username, password) => {
  localStorage.setItem(FINE_USERNAME, username)
  localStorage.setItem(FINE_PASSWORD, password)
}
// 获取用户名和密码
export const getFineUser = () => {
  const res = {
    username: localStorage.getItem(FINE_USERNAME),
    password: localStorage.getItem(FINE_PASSWORD)
  }
  return res
}
